// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__pYTlS","dragIcon":"Choice_dragIcon__4Mdq0","left":"Choice_left__1j0wE","input":"Choice_input__1-0Fh"};